import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// import Loader from "../../Assets/Img/loader1.gif";
import './loadingComponent.scss';

const LoadingComponent = ({ loading = true }) => {
    const { t } = useTranslation();
    return (
        <Modal
            show={loading}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body className="login_modal text-center">
                <h5 className="mt-2">{t('pleaseWait')}</h5>
                {/* <img src="https://miro.medium.com/max/875/1*CsJ05WEGfunYMLGfsT2sXA.gif" alt="" /> */}
                {/* <img src={Loader} alt="" width={200} /> */}
                <span className="loader"></span>
            </Modal.Body>
        </Modal>
    );
};
export default LoadingComponent;
